// extracted by mini-css-extract-plugin
export default {"projectAlert":"projectAlert__nu3gyi","projectAlertCompact":"projectAlertCompact__jmAdwD","uploadButton":"uploadButton__rnM5NM","guidance":"guidance__FeQtK3"};